export default __webpack_public_path__ + "static/1-2--8f4573bdb26e672eaa95f8120fb4a539.png";